/** React Query keys for the Procedures portal. `mode` separates the anonymous and signed-in answers. */
export type PortalMode = 'public' | 'member';

export const proceduresKeys = {
  all: ['procedures'] as const,
  settings: () => ['procedures', 'settings'] as const,
  ministries: () => ['procedures', 'ministries'] as const,
  categories: (mode: PortalMode) => ['procedures', 'categories', mode] as const,
  directory: (mode: PortalMode, search: string, categoryID: number | null) =>
    ['procedures', 'directory', mode, search, categoryID ?? 0] as const,
  view: (mode: PortalMode, code: string) => ['procedures', 'view', mode, code.toLowerCase()] as const,
  run: (runId: number) => ['procedures', 'run', runId] as const,
  myRuns: () => ['procedures', 'me', 'runs'] as const,
  chat: (mode: PortalMode, code: string, sessionKey: string) => ['procedures', 'chat', mode, code.toLowerCase(), sessionKey] as const,
};
